export const stepLabels = ['Customer Information', 'VIN Search', 'Registration Information', 'Result'];

export enum OrderSteps {
    CustomerInfo = 0,
    EnterVins = 1,
    RegistrationInfo = 2,
    Result = 3
}